import { useEffect, useState } from "react"

import If from "@mobi/components/If"
import Stepper from "@mobi/ds/components/Stepper"
import useMediaQuery from "@mobi/hooks/useMediaQuery"

import "./style.scss"

const Splitted_v2 = ({
  image = null,
  imageAlt = "",
  imageAriaHidden = "false",
  children,
  className = "",
  steps = {},
  useProposalContext = () => {},
  ...props
}) => {
  const [shouldShowImage, setShouldShowImage] = useState(false)
  const [shouldSplit, setShouldSplit] = useState(false)
  const isMobile = useMediaQuery("mobile")
  const {
    stepInfo: { currentStep },
  } = useProposalContext()
  const { stepInfo, isSplitted = true } = steps[currentStep]

  const setLayout = () => {
    const hasImage = !isMobile && image
    setShouldShowImage(hasImage)
    setShouldSplit(isSplitted)
  }

  const forceImageLoad = () => {
    const hasImage = !isMobile && image
    if (hasImage) {
      setTimeout(() => {
        setShouldShowImage(false)
        setShouldSplit(false)
        setTimeout(setLayout, 50)
      }, 50)
    }
  }

  useEffect(() => {
    setLayout()
    forceImageLoad()
  }, [isMobile, isSplitted])

  const isFullWidth =
    currentStep === "softlead" ||
    currentStep === "softlead-simulation-name" ||
    currentStep === "softlead-simulation-email" ||
    currentStep === "softlead-simulation-phone"
      ? false
      : true

  const splittedClass =
    shouldSplit || !isFullWidth ? "" : "splittedV2--fullWidth"

  return (
    <div
      className={`splittedV2 splittedV2-${currentStep} ${className} ${splittedClass}`}
      {...props}
    >
      <If
        condition={shouldShowImage && shouldSplit}
        renderIf={
          <div className="splittedV2__imageWrapper">
            <img
              src={image}
              alt={imageAlt}
              aria-hidden={imageAriaHidden}
              className="splittedV2__image"
            />
          </div>
        }
      />
      <div
        className={`splittedV2__contentScroll ${
          currentStep === "redirectApp" ? "isRedirectApp" : ""
        }`}
      >
        <div className="splittedV2__contentWrapper">
          <div className="splittedV2__contentInnerContainer">
            <If
              condition={shouldSplit && currentStep !== "redirectApp"}
              renderIf={
                <Stepper
                  title={stepInfo?.title}
                  index={stepInfo?.index}
                  max={stepInfo?.max}
                />
              }
            />
            {children}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Splitted_v2
